<template>
  <v-textarea v-model="internalNotes"
              :color="color"
              :counter="2000"
              :label="loading ? 'Saving...':'Enter a note'"
              :loading="loading"
              :maxlength="2000"
              auto-grow
              class="assessment-notes"
              outline
              @input="debounceInput">
    <template v-slot:append>
      <template v-if="loading">
        <v-progress-circular
          :color="color"
          indeterminate
          size="24"
        ></v-progress-circular>
      </template>
      <template v-else-if="notes">
        <template>
          <v-icon :color="color">check</v-icon>
        </template>
      </template>
    </template>
  </v-textarea>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'assessment-note-input',
  props: {
    userAssessment: Object
  },
  data () {
    return {
      loading: false,
      internalNotes: this.userAssessment.notes,
      notes: this.userAssessment.notes
    };
  },
  computed: {
    color () {
      return this.$t(`assessments.${this.userAssessment.assessmentName}`).color;
    }
  },
  created () {
    const that = this;
    this.debounceInput = _.debounce(function () {
      console.log('called');
      that.notes = that.internalNotes;
      that.onSave();
    }, 1000);
  },
  methods: {
    onSave () {
      this.loading = true;
      this.$store.dispatch('assessment/addAssessmentNotes', {
        userAssessmentId: this.userAssessment.assessmentId,
        notes: this.notes
      }).then(res => {
        this.$emit('updated', res);
      }).finally(() => {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      });
    },
    debounceInput () {
    }
  }
};
</script>

<style scoped>
.assessment-notes .v-input__append-inner {
  color: currentColor;
}
</style>
